export const REDUCER_NAME = 'VENUES'

